import { Translations } from '../../config/translations';
import { View } from '../view';
export class UpSellQuantityView extends View {

    id = '';
    productName = '';

    renderQuantityForm(setQuantity: Function, productName: any) {
        this.productName = productName;
        const qElem = document.createElement('input') as HTMLInputElement;
        qElem.classList.add('hs-input', 'df-input', 'df-upsell-input');

        qElem.type = 'number';
        qElem.min = '1';
        qElem.value = '1';
        qElem.setAttribute('q-for', this.formProductName(productName));

        const checkContainer = document.querySelector(`span[q-c-for="${this.formProductName(productName)}"]`);

        if (checkContainer) {
            qElem.addEventListener('input', (ev) => {
                setQuantity(Number(qElem.value), productName);
            });
            checkContainer.appendChild(qElem);
        }
    }

    showError() {
        const quantityErrorElement = this.getQuantityErrorElement();
        quantityErrorElement.innerHTML = Translations.QUANTITY_INVALID;
    }

    hideError() {
        const quantityErrorElement = this.getQuantityErrorElement();
        quantityErrorElement.innerHTML = '';
    }

    getQuantityInputElement = () => {
        return this.getHtmlElement(`#df_${this.id}_quantity`);
    }

    getQuantityErrorElement = () => {
        return this.getHtmlElement(`#${this.id}-quantity-error`);
    }

    resetQuantity() {
        const quantityInput = this.getQuantityInputElement() as HTMLInputElement;
        quantityInput.value = '1';
    }

    formProductName(prodName: string) {
        return prodName.split(' ').join('');
    }

}
